import type { OrganisationTimesheetSettings } from '@/types/timesheetSettings';
import type { RejectionRecord } from '@/types/rejection';
import { RejectionBanner, type StatusBannerVariant } from './RejectionBanner';
import { DeadlineWarningBanner } from './DeadlineWarningBanner';
import { useDeadlineWarning } from './useDeadlineWarning';

export interface TimesheetInlineAlertsProps {
  variant: StatusBannerVariant;
  isRejected: boolean;
  pendingRejection: RejectionRecord | null;
  organizationSettings: OrganisationTimesheetSettings | undefined;
  currentWeekStart: Date;
  status: string;
}

/**
 * Rejection and deadline alerts rendered inside the week toolbar, one instance
 * per responsive layout variant.
 */
export function TimesheetInlineAlerts({
  variant,
  isRejected,
  pendingRejection,
  organizationSettings,
  currentWeekStart,
  status,
}: TimesheetInlineAlertsProps) {
  const deadlineWarning = useDeadlineWarning(organizationSettings, currentWeekStart, status);
  const hasRejection = isRejected && !!pendingRejection;

  const banners = (
    <>
      <RejectionBanner variant={variant} isRejected={isRejected} pendingRejection={pendingRejection} />
      <DeadlineWarningBanner
        variant={variant}
        organizationSettings={organizationSettings}
        currentWeekStart={currentWeekStart}
        status={status}
      />
    </>
  );

  if (variant === 'mobile') {
    if (!hasRejection && !deadlineWarning) return null;
    return <div className="flex flex-col gap-1">{banners}</div>;
  }

  return <div className="flex flex-col gap-1 flex-1 min-w-0">{banners}</div>;
}
